import { Component, OnDestroy, AfterViewInit, Inject } from '@angular/core';
import { ActivatedRoute, CanActivate, Router, RouterStateSnapshot } from '@angular/router';
import { Store } from '@ngrx/store';

import * as reducers from '../../reducers';
import * as layoutActions from '../../../shared/actions/layout';

import { take } from 'rxjs/operators';
import { ANALYTICS_SERVICE_TOKEN, IAnalyticsService } from '../../../shared/services';

@Component({
  selector: 'landing',
  templateUrl: './landing.component.html',
  styleUrls: ['./landing.component.scss']
})
export class LandingComponent implements OnDestroy, AfterViewInit {
  mobileAppView: boolean;
  constructor(
    private store$: Store<any>,
    private route: ActivatedRoute,
    @Inject(ANALYTICS_SERVICE_TOKEN) private analyticsService: IAnalyticsService) {
    this.store$.dispatch(new layoutActions.SetIsFullWidthAction(true));
    this.mobileAppView = this.route.snapshot.data['mobileAppView'];
    if (this.mobileAppView) {
      this.store$.dispatch(new layoutActions.ActivateAppViewAction());
    }
  }

  ngAfterViewInit(): void {
    this.route.queryParams.pipe(take(1)).subscribe(params => {
      if (params['t']) {
        switch (params['t']) {
          case 'p':
            this.moveTo('publishFlight');
            break;
          case 'f':
            this.moveTo('fulfillFlight');
            break;
          default:
            break;
        }
      }
    });
    this.analyticsService.logEvent({eventName: 'XOViewed'});
  }

  ngOnDestroy(): void {
    this.store$.dispatch(new layoutActions.SetIsFullWidthAction(false));
    if (this.mobileAppView) {
      this.store$.dispatch(new layoutActions.DeactivateAppViewAction());
    }
  }

  moveTo(id: string): void {
    document.getElementById(id).scrollIntoView({ behavior: 'smooth', block: 'center' });
  }
}
